import actionTypes from '../constants/action-types';

const setSiteIdRecreate = (siteId) => ({
  type: actionTypes.SET_SITE_ID_RECREATE,
  payload: { siteId },
});

export default setSiteIdRecreate;
